import { get } from 'lodash';

export const starredParcels = (state = [], action) => {
  switch (action.type) {
    case 'STAR_PARCEL': {
      const id = get(action, 'payload.id');
      if (!id) return state;
      return [...state, id];
    }
    case 'UNSTAR_PARCEL': {
      const id = get(action, 'payload.id');
      if (!id) return state;
      return state.filter((storedId) => storedId !== id);
    }
    case 'CLEAR_PARCELS': {
      return [];
    }
    default:
      return state;
  }
};
